import { useMemo } from 'react';
import type { IRecordViewCounts } from './IRecordViewCounts';
import { useRecordViewsQuery } from './recordViewsApi';

/** Лічильники переглядів записів типу у просторі (бібліотека бази знань, бічна частина статті). */
export function useRecordViewCounts(ws: string, rt: string, skip = false): IRecordViewCounts {
  const { data, isSuccess, isError } = useRecordViewsQuery({ ws, rt }, { skip: skip || !ws || !rt });
  return useMemo(() => ({ counts: new Map((data ?? []).map((v) => [v.recordId, v.views])), known: isSuccess, failed: isError }), [data, isSuccess, isError]);
}
